export interface SalesPack {
  id: string;
  packNo: number;
  customerPackNo: string;
  orderNo: string;
  orderType: string;
  customerKey: string;
  customerName: string;
  shipperSupplier: string;
  deliveryDate: Date;
  productKey: string;
  productDescription: string;
  grossQuantity: number;
  nettQuantity: number;
  datePacked: Date;
  packedBy: string;
}
